import { useState, useEffect } from "react"
import OverallReport from "./OverallReport";
import QuestionWiseReport from "./QuestionWiseReport";
import useDataFetch, { DataFetchOptionsType } from "../../hooks/useDataFetch";
import { useParams } from "react-router-dom";
import { STATIC_STRINGS } from "@asez/shared";
import { overallReportAPI } from "./Services";
import RenderLoading from "./partials/RenderLoading";
import RenderError from "./partials/RenderError";

function CandidateReport() {
    const [showOverallReport , setShowOverallReport] = useState(true);
    const { candidateId } = useParams(); // using this for api call
    const buttonstyleforOverall = showOverallReport ? "bg-neutral" : "btn-outline";
    const buttonstyleforQwise = showOverallReport ? "btn-outline" : "bg-neutral";
    
    const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
    const { loading, data, error } = useDataFetch(overallReportAPI, fetchOptions);

    useEffect(() => {
    setFetchOptions({ requestId: new Date().getTime().toString() });
    }, []);

    if (loading) {
        return <RenderLoading/>;
    }
    if (error) {
      return (
        <RenderError
        error={error}
        onRetry={() => {
            setFetchOptions({
            loading: true,
            });
            setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
            }, 1000);
        }}
        />
    );
    }

  return (
    <div className="px-12 py-8 w-screen">
        <h1 className="text-4xl font-bold m-2">{data.assessmentDetails.name}</h1>
        <div className="my-6">
            <button
                className= {`px-2 py-1 text-lg rounded-3xl mx-1 ${buttonstyleforOverall}`}
                onClick={() => setShowOverallReport(true)}
            >
                {STATIC_STRINGS.OVERALL_REPORT}
            </button>
            <button
                className= {`px-2 py-1 text-lg rounded-3xl mx-1 ${buttonstyleforQwise}`}
                onClick={() => setShowOverallReport(false)}
            >
                {STATIC_STRINGS.QUESTIONWISE_REPORT}
            </button>
        </div>
        {
            showOverallReport ? (
                <OverallReport report={data}/>
            ): (
                <QuestionWiseReport/>
            )
        }
    </div>
  )
}

export default CandidateReport